import { render, staticRenderFns } from "./EditPackages.vue?vue&type=template&id=0fe1d7d0&"
import script from "./EditPackages.vue?vue&type=script&lang=js&"
export * from "./EditPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports